import { CmsRegistrationSummaryPanel } from '../../models/registration-confirmation/cms-registration-summary-panel.interface';

export const mockCmsRegistrationSummaryPanel: CmsRegistrationSummaryPanel = {
  registrationSummaryPanelTitle: 'Your confirmation details',
  registrationSummaryPanelLegal:
    'If you need to get in contact with us during your guarantee period, please provide your address and date of purchase below when you call.',
};
